var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLyk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.17578 11.9685L7.11328 13.4685C7.36328 13.7185 7.92578 13.8435 8.30078 13.8435H10.6758C11.4258 13.8435 12.2383 13.281 12.4258 12.531L13.9258 7.96855C14.2383 7.09355 13.6758 6.34355 12.7383 6.34355H10.2383C9.86328 6.34355 9.55078 6.03105 9.61328 5.59355L9.92578 3.59355C10.0508 3.03105 9.67578 2.40605 9.11328 2.21855C8.61328 2.03105 7.98828 2.28105 7.73828 2.65605L5.17578 6.46855",
    stroke: "#F7A91C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.98828 11.9688V5.84375C1.98828 4.96875 2.36328 4.65625 3.23828 4.65625H3.86328C4.73828 4.65625 5.11328 4.96875 5.11328 5.84375V11.9688C5.11328 12.8438 4.73828 13.1563 3.86328 13.1563H3.23828C2.36328 13.1563 1.98828 12.8438 1.98828 11.9688Z",
    stroke: "#F7A91C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLyk);
export default __webpack_public_path__ + "static/media/lyk.b1d92883724e0f6a3e0662c44d86b993.svg";
export { ForwardRef as ReactComponent };